import _ from 'lodash'
import { ConnectedListingLink as ListingLink } from '../../../Common/ListingLink/ListingLink'
import styles from './index.css'

const ListingInfo = props => {
  const {
    listing = {},
    tableRows
  } = props
  const listingImage = _.get(
    _.head(tableRows),
    'image',
    // 無屬性賣場為了組出可以用在修改圖片的 UI 裡，有調整結構把 listing.images 搬到 listing.models 底下
    // 預設單雙層賣場可以從 tableRows 拿到賣場主圖
    // 拿不到就當成無屬性賣場找賣場 models 第一張商品圖
    _.get(listing, 'models[0].images[0].url')
  )

  return (
    <>
      <div className={styles.listingImg}>
        {
          listingImage &&
            <img src={listingImage} />
        }
      </div>
      <div className={styles.listingInfo}>
        <p className={styles.title}>賣場編號</p>
        <p className={styles.listingId}>
          <ListingLink targetListingId={listing.id}>
            {listing.id}
          </ListingLink>
        </p>
        <p className={styles.title}>賣場名稱</p>
        <p className={styles.listingName}>{listing.name}</p>
      </div>
    </>
  )
}

export default ListingInfo
